import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { useGoogleLogin } from "@react-oauth/google";
import { Chat } from "./features/Chat/screens/Chat.component";
import { getUserAccessToken, setUserAccessToken } from "./infra/session";

import axios, { AxiosResponse } from "axios";

import { User } from "./features/Chat/interfaces/user.interface";
import Auth, { AuthLoading } from "./features/Chat/components/Auth"; 

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const recoverUser = async (accessToken: string) => {
    try {
      const result: AxiosResponse<User> = await axios.get(
        `https://www.googleapis.com/oauth2/v3/userinfo`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      setUserAccessToken(accessToken);
      setUser({
        email: result.data.email,
        name: result.data.name,
        picture: result.data.picture,
      });
    } catch (err) {
      console.log(err);
      // Clear invalid token
      setUserAccessToken("");
    } finally {
      setIsLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse: any) => recoverUser(codeResponse?.access_token),
    onError: (error: any) => {
      console.log("Login Failed:", error);
      setIsLoading(false);
    },
  });

  useEffect(() => {
    const accessToken = getUserAccessToken();
    if (accessToken) {
      recoverUser(accessToken);
    } else {
      setIsLoading(false);
    }
  }, []);

  // Loading screen
  if (isLoading) {
    return <AuthLoading />;
  }

  const logout = () => {
    setUser(null);                 
    setUserAccessToken("");        
    localStorage.removeItem("handler");
  };

  return user ? (
    <Container className="p-3">
      <Chat user={user} onLogout={logout}/>
    </Container>
  ) : (
    <Auth onLogin={() => login()} />
  );
}

export default App;